import { ExclamationCircleFilled } from '@ant-design/icons';
import { notification } from 'antd';
import {
  ERROR_DIALOG_DURATION,
  PREFIX_ERROR_MESSAGE_LENGTH
} from 'util/config/constant';
import { setErrorCode } from '../state/global/error/action';

/**
 * Display error as notification dialog
 * @param {Object | String} errorMessage
 * errorMessage = "Error message as string" | { message: "Error message as string", description: "..." }
 * @returns
 */
export const showErrorNotification = (errorMessage) => {
  let description = '';
  let message = '';

  if (typeof errorMessage === 'string') {
    message = errorMessage;
  } else if (typeof errorMessage === 'object') {
    message = errorMessage.message;
    description = errorMessage.description;
  } else {
    // eslint-disable-next-line no-console
    console.error('errorMessage is invalid format');
    return;
  }

  notification.error({
    duration: ERROR_DIALOG_DURATION,
    description,
    message,
    top: 70,
    icon: <ExclamationCircleFilled />,
    className: 'error-notification'
  });
};

export const errorHandler = (store, error) => {
  let firstErrorObject;

  if (Object.prototype.hasOwnProperty.call(error, 'graphQLErrors')) {
    firstErrorObject = error?.graphQLErrors?.find(Boolean) || {};
  } else if (Array.isArray(error)) {
    firstErrorObject = error?.find(Boolean) || {};
  }

  const errorMessage =
    firstErrorObject.message || window.globalErrorMessagesJson['999'];

  // Error message as string
  if (Number.isNaN(+errorMessage)) {
    showErrorNotification(errorMessage);
    throw error;
  }

  // Error message as code
  const suffixCode = errorMessage.slice(PREFIX_ERROR_MESSAGE_LENGTH);

  if (window.globalErrorMessagesJson[suffixCode]) {
    // Common errors 997, 998, 999
    showErrorNotification(window.globalErrorMessagesJson[suffixCode]);
  } else {
    // Specific error based on the module
    store.dispatch(setErrorCode({ errorCode: errorMessage }));
  }

  throw error;
};
